import { MissionContainer } from '../../../services/types/Missions';
import { serviceReducer } from '../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../types';

const missionReducer = (
  state: ApiState<MissionContainer, string>,
  action: Action<MissionContainer, string>
): ApiState<MissionContainer, string> => serviceReducer(state, action);

export default missionReducer;
